import * as sliderEffects from './sliders.effect';

export const effects = { ...sliderEffects };
